import React from 'react'
import ReactDOM from 'react-dom'
import { colors, theme } from '@one-tree/library'
import { createGlobalStyle } from 'styled-components'
import axios from 'axios'
import App from './App'

// Import fonts
import '@one-tree/library/dist/index.css'

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 14px;
  }
  body {
    margin: 0;
    overflow: overlay;
    ${theme.scrollbar};
    background-color: ${colors.lightGray};
  }
`
axios.defaults.baseURL = process.env.REACT_APP_API_HOST
axios.defaults.headers.post['Content-Type'] = 'application/json'

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)
